var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPebD(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.373,
    height: 28.348,
    viewBox: "0 0 96.373 28.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "peb-d_1_",
    "data-name": "peb-d (1)",
    transform: "translate(-0.68 -0.692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M95.058,12.063l-18-11.44A2.837,2.837,0,0,0,75.281,0H8.749A8.786,8.786,0,0,0,0,8.8V19.547a8.785,8.785,0,0,0,8.749,8.8H75.281A2.827,2.827,0,0,0,77,27.766L95.006,16.881a2.834,2.834,0,0,0,.052-4.818",
    transform: "translate(0.68 0.692)",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    "data-name": "Fill 2",
    d: "M18.591,0H0V22.678H18.591c0-.008,0-.014.006-.023L36.849,11.62,18.593.022c0-.008,0-.016,0-.022",
    transform: "translate(57.37 3.528)",
    fill: "#dfe143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    "data-name": "Fill 3",
    d: "M5.915,0A5.941,5.941,0,0,0,0,5.967V16.711a5.941,5.941,0,0,0,5.915,5.967H51.022V0H5.915",
    transform: "translate(3.514 3.528)",
    fill: "#3a484d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M.654,9.92A.57.57,0,0,1,0,9.276V.635A.572.572,0,0,1,.654,0H8.423A7.539,7.539,0,0,1,11.1.422c1.076.391,1.622.992,1.622,1.785V3.746A2.242,2.242,0,0,1,11.193,5.9a7.662,7.662,0,0,1-2.856.479H1.863v2.9a.551.551,0,0,1-.4.589A2.936,2.936,0,0,1,.654,9.92ZM1.863,1.475V4.887H8.448c1.609,0,2.425-.4,2.425-1.2V2.336c0-.572-.819-.861-2.434-.861Z",
    transform: "translate(9.69 9.907)",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_5",
    "data-name": "Fill 5",
    d: "M11.539,4.961c0,.528-.232.789-.7.789H1.863V7.379q0,1.051,2.395,1.051h6.584a.574.574,0,0,1,.654.643c0,.566-.218.847-.654.847H4.174a6.933,6.933,0,0,1-2.679-.5A2.12,2.12,0,0,1,0,7.446V2.524A1.926,1.926,0,0,1,.5,1.239Q1.571,0,4.333,0H6.155C6.587,0,6.8.278,6.8.83a.57.57,0,0,1-.647.643H5.626l-.1-.006-.361-.014c-.1,0-.186,0-.253,0q-3.066,0-3.065,1.075V4.26h9a.613.613,0,0,1,.688.7",
    transform: "translate(23.126 9.907)",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    "data-name": "Fill 6",
    d: "M8.567,9.92H.655A.571.571,0,0,1,0,9.276V.635A.572.572,0,0,1,.655,0h7.8a10.546,10.546,0,0,1,1.912.16,3.533,3.533,0,0,1,1.58.809A2.031,2.031,0,0,1,12.664,2.5,7.881,7.881,0,0,1,12.6,3.723a1.389,1.389,0,0,1-.109.244c-.071.126-.15.266-.252.432a3.259,3.259,0,0,0-.311.578,3.68,3.68,0,0,0,.311.514c.088.128.171.259.252.4a1.025,1.025,0,0,1,.109.252,2.693,2.693,0,0,1,.05.412c.011.178.016.409.016.728a2.244,2.244,0,0,1-1.393,2.112A6.159,6.159,0,0,1,8.567,9.92Zm-6.7-4.17V8.43h6.5c1.5,0,2.316-.316,2.42-.939a1.725,1.725,0,0,0,.012-.226c0-.112.006-.271.006-.488,0-.682-.778-1.028-2.313-1.028Zm.041-4.277V4.26h6.55c1.589,0,2.395-.31,2.395-.922,0-.169-.016-.432-.05-.83-.056-.687-.87-1.035-2.421-1.035Z",
    transform: "translate(35.698 9.907)",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_7",
    "data-name": "Fill 7",
    d: "M3.581,9.922H0V0H3.581A3.616,3.616,0,0,1,6.2.947c1.02,1.022,1.012,2.273,1,3.6,0,.125,0,.249,0,.373s0,.25,0,.374c.009,1.369.017,2.661-1,3.681A3.613,3.613,0,0,1,3.581,9.922ZM1.936,1.727V8.194H3.4A1.742,1.742,0,0,0,4.85,7.58c.36-.443.418-1.148.418-2.662S5.2,2.779,4.85,2.342A1.744,1.744,0,0,0,3.4,1.727Z",
    transform: "translate(67.939 9.907)",
    fill: "#1a1919"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPebD);
export default __webpack_public_path__ + "static/media/peb-d.bb44f74e067550a5236a84145d861ef7.svg";
export { ForwardRef as ReactComponent };